import { saturate } from 'color2k';
import { green } from '../tokens/colors.js';

function gradient(colorsArray, direction = "to right") {
  const colors = colorsArray.join(",");
  return `linear-gradient(${direction}, ${colors});`;
}
const Progress = {
  baseStyle: {
    verticalAlign: "baseline",
    track: {
      width: "100%",
      borderRadius: "0.5rem",
      bgColor: "fill-primary"
    }
  },
  sizes: {
    xs: { track: { height: "0.25rem" } },
    sm: { track: { height: "0.5rem" } },
    md: { track: { height: "0.75rem" } },
    lg: { track: { height: "1rem" } }
  },
  variants: {
    rainbow: {
      filledTrack: { background: "rainbow" }
    },
    primary: { filledTrack: { bgColor: "blue.500" } },
    success: {
      filledTrack: { bgImage: gradient([green["300"], saturate(green["700"], 1)]) }
    },
    neutral: { filledTrack: { bgColor: "text-primary" } }
  },
  defaultProps: {
    size: "md",
    variant: "primary"
  }
};

export { Progress };
